import { TStudentDetailsFeesResponse } from '../../../apis/students/studentDetails/studentDetails.interfaces';
import { TStatus } from '../../../apis/finance/finance.interfaces';

export const mockStudentDetailsFees: TStudentDetailsFeesResponse = {
  feeStructure: [],
  feeComponents: [
    {
      feeId: 'tuition-fee',
      feeType: 'Tuition Fee',
      feeDescription: 'Monthly tuition fee',
      feeAmount: 5000,
      paidAmount: 5000,
      pendingAmount: 0,
      status: TStatus.PAID,
      isOptional: false,
    },
    {
      feeId: 'library-fee',
      feeType: 'Library Fee',
      feeDescription: 'Annual library fee',
      feeAmount: 1000,
      paidAmount: 500,
      pendingAmount: 500,
      status: TStatus.PARTIAL,
      isOptional: false,
    },
    {
      feeId: 'sports-fee',
      feeType: 'Sports Fee',
      feeDescription: 'Annual sports fee',
      feeAmount: 2000,
      paidAmount: 0,
      pendingAmount: 2000,
      status: TStatus.UNPAID,
      isOptedOut: true,
      isOptional: true,
    },
  ],
  totalExpected: 8000,
  totalPaid: 5500,
  totalPending: 2500,
};
